$(document).ready(function(){

    $('#addressFormSubmit').click(function(){

        var address = $('#address1').val();
        var cityId = $('#city_id').val();
        var postalcode = $('#postalcode').val();
        var selectedText = $('#city_id option:selected').text();
        var population = $('#population').val();

        // Actualizar valores de campos hidden
        $('#address').val(address);
        $('input[name="location_id"]').val(cityId);
        $('input[name="postalcode"]').val(postalcode);
        $('[name="plannum"]').val($('#plannum').val());
        $('input[name="population"]').val(population);

        $('#address_text').text(address);
        $('#postalcode_text').text(postalcode);
        $('#plannum_text').text('Num plano: ' + $('#plannum').val());
        if (cityId == 1) {
            $('#city_text').text(population);
        } else {
            $('#city_text').text(selectedText);
        }

        // Cerrar el modal
        $('#address_add').modal('hide');
    });

    setTimeout(function() {
        $('#successMessage').fadeOut('slow');
    }, 3000);

    $('#addressFacFormSubmit').click(function(){
        var address = $('#address2').val();
        var cityId = $('#city_id2').val();
        var postalcode = $('#postalcode2').val();
        var population = $('#population2').val();
        console.log($('#population2').val());
        var selectedText = $('#city_id2 option:selected').text();
        var nif = $('#nif2').val()
        var name2 = $('#name2').val();
        var last_name2 = $('#last_name2').val();

        // Actualizar valores de campos hidden
        $('input[name="address_fac"]').val(address);
        $('input[name="location_id_fac"]').val(cityId);
        $('input[name="population_fac"]').val(population);
        $('input[name="postalcode_fac"]').val(postalcode);
        $('[name="plannum_fac"]').val($('#plannum2').val());
        $('input[name="nif_fac"]').val(nif);
        $('input[name="active_fac"]').val(1);
        $('input[name="name_fac"]').val(name2);
        $('input[name="last_name_fac"]').val(last_name2);

        $('#address_text_fac').text(address);
        $('#postalcode_text_fac').text(postalcode);
        /* $('#plannum_text_fac').text('Num plano: ' + $('#plannum2').val()); */
        if (cityId == 1) {
            $('#city_text_fac').text(population);
        } else {
            $('#city_text_fac').text(selectedText);
        }

        $('#nif_text_fac').text(nif);
        $('#name_text_fac').text(name2);
        $('#last_name_text_fac').text(last_name2);

        // Cerrar el modal
        $('#address_fac').modal('hide');
    });



});

document.addEventListener('DOMContentLoaded', function() {
    const citySelect = document.getElementById('city_id2');
    const populationField = document.getElementById('population2_group');

    function togglePopulationField() {
        if (citySelect.value == '1') {
            populationField.style.display = 'block';
        } else {
            populationField.style.display = 'none';
        }
    }

    togglePopulationField();

    citySelect.addEventListener('change', togglePopulationField);
});

document.addEventListener('DOMContentLoaded', function() {
    const citySelect = document.getElementById('city_id');
    const populationField = document.getElementById('population_group');

    function togglePopulationField() {
        if (citySelect.value == '1') {
            populationField.style.display = 'block';
        } else {
            populationField.style.display = 'none';
        }
    }

    togglePopulationField();

    citySelect.addEventListener('change', togglePopulationField);
});
